import React from "react";
import { Link } from "gatsby";
import { unslugify } from "./slugify";
import { TopList } from "../templates/fragments/top-list";
import { monthSlugs } from "./centralStore";
import { getVtUrl } from "../components/afils/useAfilsUrls";

export const replacePlaceholdersWithLinks = ({
    text,
    slugMap,
    nameMap,
    slug,
    topListData
}: {
    text: string;
    slugMap: Record<string, string>;
    nameMap: Record<
        string,
        {
            name: string;
            isSingle?: boolean;
            afData?: {
                vtUrl: string;
            };
        }
    >;
    slug?: string;
    topListData: TopList;
}) => {
    if (!text) return text; // Return empty string if text is falsy

    const regex = /##(.*?)##/g; // Matches ##slug##
    const parts = text.split(regex);

    return parts.map((part, index) => {
        if (part.startsWith("ACTIVITIES-")) {
            const flightPart = part.replace("ACTIVITIES-", "");
            const vtUrl = slug
                ? getVtUrl(nameMap[slug].afData?.vtUrl, 4)?.viatorUrl
                : undefined;
            if (!vtUrl) return flightPart; // Return plain text if no vtUrl found
            return (
                <Link
                    className="app-href"
                    key={index}
                    to={getVtUrl(nameMap[slug].afData?.vtUrl, 4).viatorUrl}
                    target="_blank"
                >
                    {flightPart}
                </Link>
            );
        }

        if (slugMap[part]) {
            const name = nameMap[part]?.name;
            const isSingle = nameMap[part]?.isSingle ?? true;
            const link = slugMap[part].replace(
                /##MONTH##/g,
                isSingle ? "climate" : getMonth(topListData)
            );
            return (
                <Link className="app-href" key={index} to={`/${link}`}>
                    {name || unslugify(part)}
                </Link>
            );
        }
        return part.length > 3 && !part.includes(" ") ? unslugify(part) : part; // Return plain text if no match
    });
};

export const prepareNameMap = (completeList: TopList) => {
    const nameMap: Record<
        string,
        {
            name: string;
            isSingle?: boolean;
            afData?: {
                vtUrl: string;
            };
        }
    > = {};
    completeList.additionalData.resorts.forEach((resort) => {
        nameMap[resort.slug] = {
            name: resort.name,
            isSingle: resort.isSingle,
            afData: resort.afData
        };
    });
    completeList.additionalData.regions.forEach((region) => {
        nameMap[region.slug] = {
            name: region.name,
            isSingle: false,
            afData: region.afData
        };
    });
    completeList.additionalData.otherResorts?.forEach((resort) => {
        nameMap[resort.slug] = { name: resort.name, isSingle: resort.isSingle };
    });
    return nameMap;
};

const getMonth = (topListData: TopList) => {
    const monthConstraint = topListData.additionalData.constraints.find(
        (constraint) => constraint.constraint === "month"
    );
    let monthIndex = new Date().getMonth();
    if (monthConstraint?.constraintArray?.length) {
        monthIndex = monthConstraint.constraintArray[1];
    }
    if (monthConstraint?.constraintNumber) {
        monthIndex = monthConstraint.constraintNumber - 1;
    }
    return monthSlugs[monthIndex];
};
